import React, { useState, useEffect } from "react";
import MapLayersWidget from "../../widgets/esri/mapLayers/MapLayersWidget";
import BookMarksWidget from "../../widgets/esri/bookmarks/BookMarksWidget";
import BasemapGalleryWidget from "../../widgets/esri/basemap-gallery/BasemapGalleryWidget";
import MeasurementWidget from "../../widgets/custom/measurement/MeasurementWidget";
import Toolbar from "../../components/toolbar/Toolbar";
import ExportLayersWidget from "../../widgets/custom/export-layers/ExportLayersWidget";
import PrintMapWidget from "../../widgets/esri/print-map/PrintMapWidget";
import DrawToolWidget from "../../widgets/custom/draw-tool/DrawToolWidget";
import EditorWidget from "../../widgets/esri/editor/EditorWidget";
import SelectFormWidget from "../../widgets/custom/select-form/SelectFormWidget";
import FeatureWidget from "../../widgets/esri/feature/FeatureWidget";
import MonumentProjectWidget from "../../widgets/custom/monuments/monument-project/MonumentProjectWidget";
import SeniorInspReview from "../../widgets/custom/op-maint-inspections/senior-inspect/SeniorInspReview";

const Drawer = ({ view, setPage, page, tool, hideDrawer, setHideDrawer, pageConfig, mapId, portal,setHorizPanelHeight,tableSplit,setTableSplit}) => {

  const [activePanelTool, setActivePanelTool] = useState("");
  const [toolHeader, setToolHeader] = useState("");
  const [resetFlag, setResetFlag] = useState(false)
  const resetTabArray = () => {
    setResetFlag(true)
  }

  useEffect(() => {
    setActivePanelTool(tool);
  }, [tool]);

  useEffect(() => {
    if(tool === 'bookmarks') {
      setToolHeader('Bookmarks');
    } else if(tool === 'basemapGallery') {
      setToolHeader('Basemap Gallery');
    } else if(tool === 'DrawToolWidget') {
      setToolHeader("Draw");
    } else if(tool === 'editorWidget') {
      setToolHeader('Editor');
    } else if(tool === 'measurementTool') {
      setToolHeader(" Measure");
    } else if(tool === 'PrintMapWidget') {
      setToolHeader('Print');
    } else if(tool === 'seniorInspReview') {
      setToolHeader('Senior Inspector Review');
    }
  }, [tool]);


  return (
    <>

      <div
        className="drawer scroll scroll--alt"
        style={hideDrawer === false ? { display: 'none' } : { display: 'block' }}
      >

        <div className="drawer__title">

          {
            //https://stackoverflow.com/questions/46592833/how-to-use-switch-statement-inside-a-react-component
            {
              tools: "Tools",
              layers: "Layers",
              selection: "Selection",
              identify: "Identify",
              seniorInspReview: "Senior Inspector Review",
              monuments:"Monuments"
            }[page]
          }
        </div>

        <div className="parcel" style={page === "tools" ? { display: 'block' } : { display: 'none' }}>
          <Toolbar>
            <h1>{toolHeader}</h1>
          </Toolbar>
          <span></span>
          {pageConfig.widgets.bookmarks && <BookMarksWidget activeWidget={activePanelTool} view={view} mapId={mapId} />}
          {pageConfig.widgets.basemapGallery.show &&
            <BasemapGalleryWidget activeWidget={activePanelTool} view={view} portal={portal} query={pageConfig.widgets.basemapGallery.query} />}
          {pageConfig.widgets.print.show && <PrintMapWidget activeWidget={activePanelTool} view={view} serviceUrl={pageConfig.widgets.print.serviceUrl} />}
          {pageConfig.widgets.draw && <DrawToolWidget activeWidget={activePanelTool} view={view} pageConfig={pageConfig} />}
          {pageConfig.widgets.measure && <MeasurementWidget page={page}activeWidget={activePanelTool} view={view} />}
          {/* <ExportLayersWidget activeWidget={activePanelTool} view={view} /> */}
          {pageConfig.widgets.editor && <EditorWidget activeWidget={activePanelTool} view={view} />}

        </div>
        <div className="parcel" style={page === "monuments" ? { display: 'block' } : { display: 'none' }}>
        <MonumentProjectWidget activeWidget={activePanelTool} view={view} />
            </div>
        <div className="parcel" style={page === "layers" ? { display: 'block' } : { display: 'none' }}>
          {<MapLayersWidget activeWidget={'mapLayers'} view={view} mapId={mapId} />}
        </div>
        <div className="parcel" style={page === "identify" ? { display: 'block' } : { display: 'none' }}>
          <FeatureWidget activeWidget={'feature'} view={view} pageConfig={pageConfig} openPage={{ page: page, compareVariable: "identify", callback: (e) => setPage(e), setHideDrawer: (e) => setHideDrawer(e) }}></FeatureWidget>
        </div>

        <div className="parcelSelection" style={page === "selection" ? { display: 'block' } : { display: 'none' }}>
          {<SelectFormWidget view={view} portal={portal} activeWidget={'select'} setHorizPanelHeight={setHorizPanelHeight} tableSplit={tableSplit} setTableSplit={setTableSplit} pageConfig={pageConfig} resetTabArray={resetTabArray}/>}
        </div>
        {pageConfig.widgets?.opMaintInspectionTools?.show&&<div className="parcel" style={page === "seniorInspReview" ? { display: 'block' } : { display: 'none' }}>
        <SeniorInspReview view={view} activeWidget={"seniorInspReview"} portal={portal} />
       </div>}
      </div>

    </>
  );

};

export default Drawer;











